import React, {Fragment, useState} from 'react';
import {connect, useSelector} from 'react-redux';

import Breadcrumb from '../../../components/common/breadcrumb';

import InvoiceForm from '../form';

import {createInvoice} from '../../../actions/invoice.action';

const InvoiceIncomeCreate = ({history, createInvoice}) => {
	const accessToken = useSelector(content => content.user.accessToken);
	const [isLoading, setIsLoading] = useState(false);

	return (
		<Fragment>
			<Breadcrumb title="Létrehozás" parent={[{title: 'Bevételek'}, {title: 'Számlák'}]}/>
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						<InvoiceForm
							isLoading={isLoading}
							isCreate={true}
							isIncome={true}
							submitFunction={async (data) => {
								setIsLoading(true);
								await createInvoice(accessToken, data)
									.then(() => {
										setIsLoading(false);
										history.push(`${process.env.PUBLIC_URL}/invoices`);
									})
									.catch(err => {
										setIsLoading(false);
									});
							}}
						/>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default connect(null, {createInvoice})(InvoiceIncomeCreate);
